module.exports = __webpack_public_path__ + "static/img/icon_fail.3769d089.svg";